module.exports = __webpack_public_path__ + "static/img/2-6.2.5.373e707.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/5/2-6.2.5.png
// module id = dBnn
// module chunks = 0